import { render, staticRenderFns } from "./GGaugeChart.vue?vue&type=template&id=b1cd24e6&"
import script from "./GGaugeChart.vue?vue&type=script&lang=js&"
export * from "./GGaugeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports